export default __webpack_public_path__ + "static/media/mice_02.2690deac.png";